import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid } from '@material-ui/core';
import CustomTypo from '../../components/CustomTypo';
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';
import {SwichActiveIcon, SwichGreenActiveIcon, SwichIcon} from '../../components/icons'

    const styles = theme => ({
        email:{
            marginTop: theme.spacing(8),
            cursor: 'pointer'
        },
        sms:{
            marginTop: theme.spacing(4),
            cursor: 'pointer'
        }

});

function SettingsView(props) {
    const { classes, t, showLoading, email_opt_out,app_name, onUpdateMarketingInformation, sms_opt_out, currentLanguge, onChangeLanguage} = props
    return (
        <div>
            <DrawerCustom
                open={props.open}
                onClose={() => props.onClose()}
                title = {t('setting_title')}
                children={<DrawerItem classes={classes} t={t} 
                    showLoading = {showLoading}
                    email_opt_out ={email_opt_out}
                    app_name = {app_name}
                    onUpdateMarketingInformation = {onUpdateMarketingInformation}
                    sms_opt_out = {sms_opt_out}
                    currentLanguge = {currentLanguge}
                    onChangeLanguage = {onChangeLanguage}

            />}/>

        </div>
    );
}
function DrawerItem(props) {
    const { t, classes, showLoading, email_opt_out, app_name,onUpdateMarketingInformation, sms_opt_out, onChangeLanguage, currentLanguge} = props;
    return (
        <Grid item>
            <Grid xs={12}>
                <CustomTypo variant="subtitle2" color='onPrimary'>{t('marketing_information')}</CustomTypo>
            </Grid>
            <Grid xs={12}>
    <CustomTypo variant="body2" color='onPrimary'>{t('marketing_information_desc')}{app_name}{" "}{t('marketing_information_desc_2')}</CustomTypo>
            </Grid>
            
            {<Grid item xs={12} container className={classes.email} onClick={() => onUpdateMarketingInformation('email_opt_out', !email_opt_out)}>
                <Grid xs={10} item container justify='flex-start'>
                    <CustomTypo color='onPrimary'>{t('setting_email')}</CustomTypo>
                </Grid>
                <Grid xs={2} item container justify='flex-end'>
                    {showLoading?<CustomizedCircularProgress/>:(email_opt_out ? <SwichGreenActiveIcon /> : <SwichIcon />)}
                </Grid>
            </Grid>}
            
            {<Grid item xs={12} container className={classes.sms} onClick={() => onUpdateMarketingInformation('sms_opt_out', !sms_opt_out)}>
                <Grid xs={10} item container justify='flex-start'>
                    <CustomTypo color='onPrimary'>{t('setting_sms')}</CustomTypo>
                </Grid>
                <Grid xs={2} item container justify='flex-end'>
                    {showLoading?<CustomizedCircularProgress/>:(sms_opt_out ? <SwichGreenActiveIcon /> : <SwichIcon />)}
                </Grid>
            </Grid>}
            <hr/>
            {<Grid item xs={12} container className={classes.sms} onClick={() => onChangeLanguage()}>
                <Grid xs={10} item container justify='flex-start'>
                    <CustomTypo color='onPrimary'>{t('setting_language')}</CustomTypo>
                </Grid>
                <Grid xs={2} item container justify='flex-end'>
                    <CustomTypo color='onPrimary'>{currentLanguge=== 'ENG' ?t('english'):t('greek')}</CustomTypo>
                </Grid>
            </Grid>}
            {/* {showLoading && <CustomizedCircularProgress />} */}
        </Grid>
    )
}

export default withStyles(styles)(withTranslation()(SettingsView));